import React from "react";
import { connect } from "react-redux";

// import moment from "moment";
import campaignResultDefaultImg from '../../../assets/images/campaignResult-default.png'
import './campaignErrorResult.css'
import LeftArrowImg from '../../../assets/images/left-arrow.png'
import RightArrowImg from '../../../assets/images/right-arrow.png'


export class CampaignErrorResult extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1

        }

    }


    getErrorLogData = () => {

        let sortedArray = this.props.campaignErrorLogs.slice(25 * this.state.currentPage - 25, 25 * this.state.currentPage)
        let JSX = [];


        sortedArray.forEach((entry) => {
            JSX.push(<tr className="CampaignErrorResult-value" key={entry.id}>
                <td className="CampaignErrorResult-date-value">{entry.InsertedOn.split('.')[0].replace('T', ' ')}</td>
                <td>{entry.CampaignID}</td>
                <td className="CampaignErrorResult-description-value">{entry.ErrorDescription}</td>
            </tr>)
        })

        return JSX;

    }

    moveNextPage = () => {
        if (this.state.currentPage < this.props.maxPage) {
            this.setState({ currentPage: this.state.currentPage + 1 })
        }
    }
    movePreviousPage = () => {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: this.state.currentPage - 1 })
        }
    }

    conditionalRendering = () => {
        if (this.props.campaignErrorLogs) {
            return (<div className="CampaignErrorResult">

                <div className="CampaignErrorResult-log-details-container">
                    <table className="CampaignErrorResult-log-details">
                        <thead>
                            <tr>
                                <th className="CampaignErrorResult-date">Date</th>
                                <th className="CampaignErrorResult-schedule">CampaignID</th>
                                <th className="CampaignErrorResult-description">Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.getErrorLogData()}
                        </tbody>
                    </table>
                </div>
                <div className="CampaignErrorResult-pagination">
                    <div className="CampaignErrorResult-pagination-count">{this.state.currentPage} of {this.props.maxPage}</div>

                    <div className="CampaignErrorResult-pagination-buttongroup">
                        <button className="CampaignErrorResult-pagination-button-previous" onClick={this.movePreviousPage}>
                            <img src={LeftArrowImg} alt="Previous" ></img>
                        </button>
                        <button className="CampaignErrorResult-pagination-button-next" onClick={this.moveNextPage}>
                            <img src={RightArrowImg} alt="Next" ></img>
                        </button>
                    </div>
                </div>

            </div>)
        } else {
            return (<div className="CampaignResult-default">
                <img src={campaignResultDefaultImg} alt="Default" />
                <div> Let The Search Begin!</div>
            </div>)
        }
    }



    render() {
        return (
            <React.Fragment>
                {this.conditionalRendering()}
            </React.Fragment>

        )
    }
}

const mapStateToProps = (state) => {
    if (state.logs.campaignErrorLogs.logs && state.logs.campaignErrorLogs.logs.length) {
        //showing 25 entries max per page
        return { campaignErrorLogs: state.logs.campaignErrorLogs.logs, maxPage: state.logs.campaignErrorLogs.logs.length % 25 === 0 ? state.logs.campaignErrorLogs.logs.length / 25 : Math.ceil(state.logs.campaignErrorLogs.logs.length / 25) };
    } else {
        return { campaignErrorLogs: null, maxPage: 1 }
    }
};

export default connect(mapStateToProps)(CampaignErrorResult);
